var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "100%",
          height: "100%",
          "background-color": "#fff"
        }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "weui_msg content-row content-align-center content-row-column auto-width"
          },
          [
            _c("div", { staticClass: "weui_icon_area" }, [_vm._v("i")]),
            _vm._v(" "),
            _c("div", { staticClass: "weui_text_area" }, [
              _c("h4", { staticClass: "weui_msg_title" }, [
                _vm._v("请在微信客户端扫描二维码")
              ])
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00e4705f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00e4705f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wechat_error.vue
// module id = null
// module chunks = 